module.exports = __webpack_public_path__ + "static/media/lambo-large.d0cd8584.jpg";